import { render, staticRenderFns } from "./duplicate.vue?vue&type=template&id=4d72ef97&scoped=true"
import script from "./duplicate.vue?vue&type=script&lang=ts"
export * from "./duplicate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72ef97",
  null
  
)

export default component.exports